import { render } from "./KnifePage.html?vue&type=template&id=6101f289&external"
import script from "./KnifePage.vue?vue&type=script&lang=js"
export * from "./KnifePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__